import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { guestRegistrationOnEVisitor } from 'modules/_common/api';

export const useMutationMultipleGuestRegistrationOnEVisitor = () => {
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  return useMutation(guestRegistrationOnEVisitor, {
    onSuccess: () => {
      successToast();
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_GUESTS);
      queryClient.invalidateQueries(QUERY_KEYS.EVISITOR_GUESTS);
    },
    onError: () => errorToast(),
  });
};
